import Vue from 'vue'

let configs = {
  region: 'kz',
  auth: {
    url: 'http://localhost/',
    client_id: 2,
    client_secret: 'xQlRp3LVRjyyudqta2bUzhi9xcjxhAfDTvsFYYEb',
    grant_type: 'password',
    host: 'http://localhost',
    methods: {
      login: '/api/v1/user/auth/access_token'
    }
  }
}

Vue.config.webConfig = configs



// WEBPACK FOOTER //
// ./src/config/index.js